/* generated by pull.js */
import _js from "./userscript.js";
export const resources = {
  "userscript.js": _js,
};
